"use strict";

exports.__esModule = true;
exports.validateDraftFieldNotEmpty = void 0;

var _lodash = require("lodash");

var validateDraftFieldNotEmpty = function validateDraftFieldNotEmpty(field, fallback) {
  return (0, _lodash.trim)(field).length ? field : fallback;
};

exports.validateDraftFieldNotEmpty = validateDraftFieldNotEmpty;